import React from 'react';

const ArrowUp = ({ className }: { className?: string }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 17.6 23.784"
			className={className}
		>
			<path
				fill="currentColor"
				d="M9.672.238a.146.146 0 0 0-.119-.04.3.3 0 0 0-.159-.079c-.04 0-.079-.04-.159-.04-.04 0-.119-.04-.159-.04-.079 0-.159-.04-.238-.04h-.157a.5.5 0 0 0-.238.04c-.079 0-.119.04-.159.04s-.079.04-.119.04c-.079.04-.119.079-.2.119-.04 0-.04.04-.079.04-.079.079-.159.119-.238.2L.476 7.651a1.579 1.579 0 0 0 0 2.259 1.579 1.579 0 0 0 2.259 0l4.479-4.479v16.767a1.586 1.586 0 0 0 3.171 0V5.431l4.479 4.479a1.584 1.584 0 1 0 2.259-2.22L9.91.476Z"
			/>
		</svg>
	);
};

export default ArrowUp;
